"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Adds MODIFIER to an order item.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type AddModifierEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    const orderItem = order.orderItems.find(_orderItem => _orderItem.id === event.orderItemId);
    if (orderItem === undefined) {
        return order;
    }
    if (!orderItem.modifiers) {
        orderItem.modifiers = [];
    }
    const matchedModifier = orderItem.modifiers.find(mod => mod.modifierGroupId === event.modifierGroupId &&
        mod.id === event.modifierId &&
        mod.unitPrice === event.unitPrice);
    if (matchedModifier) {
        matchedModifier.quantity = event.quantity;
    }
    else {
        if ((event === null || event === void 0 ? void 0 : event.modifierGroupPriority) >= 0) {
            const priority = event.modifierGroupPriority;
            const indexToInsert = orderItem.modifiers.findIndex(currentObject => currentObject.modifierGroupPriority > priority);
            if (indexToInsert === -1) {
                orderItem.modifiers.push({
                    unitPrice: event.unitPrice,
                    quantity: event.quantity,
                    taxes: event.taxes,
                    id: event.modifierId,
                    name: event.name,
                    modifierGroupId: event.modifierGroupId,
                    modifierGroupPriority: event.modifierGroupPriority,
                    alternateNames: (event === null || event === void 0 ? void 0 : event.alternateNames) || [],
                    isDefault: event === null || event === void 0 ? void 0 : event.isDefault,
                });
            }
            else {
                orderItem.modifiers.splice(indexToInsert, 0, {
                    unitPrice: event.unitPrice,
                    quantity: event.quantity,
                    taxes: event.taxes,
                    id: event.modifierId,
                    name: event.name,
                    modifierGroupId: event.modifierGroupId,
                    modifierGroupPriority: event.modifierGroupPriority,
                    alternateNames: (event === null || event === void 0 ? void 0 : event.alternateNames) || [],
                    isDefault: event === null || event === void 0 ? void 0 : event.isDefault,
                });
            }
        }
        else {
            orderItem.modifiers.push({
                unitPrice: event.unitPrice,
                quantity: event.quantity,
                taxes: event.taxes,
                id: event.modifierId,
                name: event.name,
                modifierGroupId: event.modifierGroupId,
                alternateNames: (event === null || event === void 0 ? void 0 : event.alternateNames) || [],
                isDefault: event === null || event === void 0 ? void 0 : event.isDefault,
            });
        }
    }
    order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    if (orderItem.adjustments) {
        orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
        orderItem.surchargeAmount = (0, computePrice_1.computeOrderItemSurcharge)(orderItem);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=addModifier.js.map